import Auth from '@aws-amplify/auth'
import { firstTimeLogin } from '../redux/user/actions'
import { notification, analytics } from './index'

export default async function login(username, password, payload) {
  try {
    return await Auth.signIn(username, password)
      .then(async (user) => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          if (payload.newPassword !== undefined) {
            const { newPassword } = payload
            const email = username
            await Auth.completeNewPassword(
              user, // the Cognito User Object
              newPassword, // the new password
              // OPTIONAL, the required attributes
              {
                email,
              },
            )
            await firstTimeLogin()
            if (user.challengeName === 'SMS_MFA') {
              notification.warning('Verification', 'One-Time Password is required')
              return {
                OTPReq: true,
                userDetails: {
                  userObj: user,
                  username,
                  password,
                },
                error: 'One-Time Password Required',
              }
            }

            return {
              success: true,
              type: 'Coach',
            }
          }
          notification.warning('Change your password', 'New password required')
          return {
            newPassReq: true,
            userDetails: {
              username,
              password,
            },
            error: 'New Password Required',
          }
        }
        if (user.challengeName === 'SMS_MFA') {
          notification.warning('Verification', 'One-Time Password is required')
          return {
            OTPReq: true,
            userDetails: {
              userObj: user,
              username,
              password,
            },
            error: 'One-Time Password Required',
          }
        }
        return {
          success: true,
          type: 'Coach',
        }
      })
      .catch((e) => {
        notification.warning('Invalid Login', e.message)
        return {
          success: false,
          error: 'invalid Username or Password',
        }
      })
  } catch (e) {
    notification.warning('Invalid Login', e.message)
    return {
      success: false,
      error: 'invalid Username or Password',
    }
  }
}

export async function Verification(payload) {
  try {
    if (payload.OTP !== undefined) {
      return await Auth.confirmSignIn(payload.userDetails.userObj, payload.OTP, 'SMS_MFA')
        .then(() => {
          notification.success('Valid OTP')
          return {
            OTPReq: false,
            success: true,
            type: 'Coach',
          }
        })
        .catch((e) => {
          notification.warning('Invalid OTP', e.message)
          return {
            OTPReq: true,
            userDetails: {
              userObj: payload.userDetails.userObj,
              username: payload.username,
              password: payload.password,
            },
            error: 'One-Time Password Required',
          }
        })
    }
  } catch (e) {
    return {
      success: false,
      error: e,
    }
  }
}
export async function currentAccount() {
  try {
    let firstName = ''
    let lastName = ''
    let userID = ''
    let CoachImage = 'Doctor.png'
    await Auth.currentSession().then(async () =>
      Auth.currentUserInfo().then((user) => {
        firstName = user.attributes['custom:first_name']
        lastName = user.attributes['custom:last_name']
        userID = user.attributes.sub

        // set userId for analytics
        analytics.setUser({ userId: userID, email: user.attributes.email })
        analytics.pageView(`${window.location.hash}${window.location.search}`)

        if (userID === '6748ab69-bbce-47fc-ae7b-93e9a94af76c') {
          CoachImage = 'MaxKirsten.png'
        }
      }),
    )
    return await Auth.currentSession().then(async (ses) =>
      Auth.currentUserCredentials().then(() => {
        const { idToken } = ses
        const { jwtToken } = idToken
        const groups = idToken.payload['cognito:groups']

        return {
          name: 'Coach',
          role: 'Coach',
          CoachImage,
          groups,
          userID,
          fullName: `${firstName} ${lastName}`,
          jwtToken,
          status: true,
        }
      }),
    )
  } catch (e) {
    window.log('Error Loading current Account', e)
    return {
      status: false,
    }
  }
}
export async function logout() {
  await Auth.signOut().then(() => true)
}
